import { AfterViewInit, Component, OnInit, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, Subject, SubscriptionLike } from 'rxjs';
import { EmailComposeComponent } from './email-compose/email-compose.component';
import { EmailDraftsComponent } from './email-drafts/email-drafts.component';
import { EmailListComponent } from './email-list/email-list.component';
import { EmailReadComponent } from './email-read/email-read.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';

@Component({
  selector: 'app-correspondence',
  templateUrl: './correspondence.component.html',
  styleUrls: ['./correspondence.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CorrespondenceComponent implements OnInit {
  subGetData: SubscriptionLike;

  @Input() ApplicationID: string;
  @Input() ModuleID: string;
  @Input() SubModule: string;

  @ViewChild(EmailListComponent) emailListcomp: EmailListComponent;
  @ViewChild(EmailReadComponent) emailDisplay: EmailReadComponent;

  MessageID: string | null = null;
  mailFolder: "I" | "O" = "I";
  inboxCount$: Observable<string> = of('0');
  outboxCount$: Observable<string> = of('0');
  draftCount$: Observable<string> = of('0');
  action: Subject<any> = new Subject();
  FormEmailId: string;

  @Output() ProjectID_Emit: string = "Test PID";

  userType: string;
  permission: string = "";

  constructor(private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    public route: ActivatedRoute,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,  
    public apiService: ApidataRequestService) { }

  ngOnInit() {   
      // let appid=this.commonService.appId;
      // let scid=this.commonService.ScreenID;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {   
        this.ModuleID = this.commonService.getModuleId(params['module']);
        this.ApplicationID = this.commonService.appId;//params['id'];
        this.SubModule = params['submodule'];
      }
    });
    this.permission = "";
    var lper = this.commonService.getPagePermission("IST14");
    if (lper != null && lper) {
       ;
      this.permission = lper.toLowerCase();
    }
    this.userType = this.userService.getUserType();
   // this.getCount();   
   this.getMailCount();
    setTimeout(() => {     
      this.emailListcomp.initialize(this.mailFolder, this.ApplicationID,this.ModuleID,this.SubModule);
    }, 10);
  }


  getCount() {
    // this.inboxCount$ = this.getMailCount().pipe(map(x => x.Data?.InboxCount));
    // this.outboxCount$ = this.getMailCount().pipe(map(x => x.Data?.OutboxCount));
    // this.draftCount$ = this.getMailCount().pipe(map(x => x.Data?.DraftsCount));

    // this.inboxCount$ = this.getMailCount().pipe(map(x => x.Data.InboxCount + ''));
    // this.outboxCount$ = this.getMailCount().pipe(map(x => x.Data.OutboxCount + ''));
    // this.draftCount$ = this.getMailCount().pipe(map(x => x.Data.DraftsCount + ''));
    
  }
  ngOnDestroy(): void {
    if (this.subGetData)
      this.subGetData.unsubscribe();   
  }
  getMailCount() {    
   // return this.serviceConstants.apiURL.getData("api/Correspondence/GetEmailCount?ApplicationID=" + this.ApplicationID + "&ModuleID=" + this.ModuleID).pipe(share());
   this.subGetData = this.apiService.getData("api/Correspondence/GetEmailCount?ApplicationID=" + this.ApplicationID + "&ModuleID=" + this.ModuleID+"&SubModule="+this.SubModule).subscribe(result => {
    if (result.Status) {       
      this.inboxCount$ = of(result.Data.InboxCount + '');
      this.outboxCount$ = of(result.Data.OutboxCount + '');
      this.draftCount$ = of(result.Data.DraftsCount + '');
      this.FormEmailId = result.Data.FromEmail;

    }  
  });
  
  }

  loadEmails(type) {
    // this.getCount();
   this.getMailCount();
    this.mailFolder = type;
    this.MessageID = null;
    this.emailListcomp.ApplicationID = this.ApplicationID;
    this.emailListcomp.ModuleID = this.ModuleID;
    this.emailListcomp.SubModule =this.SubModule
    this.emailListcomp.IsAdvanceSearch = false;
    this.emailListcomp.initialize(this.mailFolder, this.ApplicationID,this.ModuleID,this.SubModule);
  }

  loadMessage(emitObj: any) {
    
     let messageID = emitObj.msgID;
     let emailFolder = emitObj.folder;
     if (messageID) {
      // console.log(messageID + " From Parent");
       this.MessageID = messageID;
       this.emailDisplay.initialize(emailFolder, messageID);       
    } 
  }

  composeMail() {
    var err: any = [];
    // if (this.FormEmailId != null && this.FormEmailId != "" && this.FormEmailId != undefined) {
      this.mailFolder = 'O';
      this.MessageID = null;
      let modalRef1 = this.modalService.open(EmailComposeComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef1.componentInstance.Content={
        heading: 'Compose',
        content: { ApplicationID: this.ApplicationID, ModuleID: this.ModuleID,SubModule:this.SubModule, MailType: "new" }
      }
      modalRef1.result.then(result => {
        
        // this.getCount();
       // this.getMailCount();
        this.loadEmails('O');
      })
    // }
    // else {
    //   err.push('Outgoing emails related to correspondence for this organization is not configured');
    //   this.commonService.ValidationBanner(err);
    // }
  }

  drafts() {
    this.mailFolder = 'O';
    this.MessageID = null;
    let modalRef = this.modalService.open(EmailDraftsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Drafts',
      Content: {ApplicationID: this.ApplicationID, ModuleID: this.ModuleID,SubModule:this.SubModule, Permission:this.permission}
    }
    modalRef.result.then(result => {       
      this.getMailCount();
    })
  }

  RefreshCountDetails() {
   // this.getMailCount();
   this.loadEmails('O');
  }
  
}
export class EmailMetaData {
  public MsgID: string
  public HasAttachment: boolean
  public IsHighImp: boolean
  public FromEmail: string
  public IsReplied: boolean
  public IsForwaded: boolean
  public HasReadReceipts: boolean
  public MailDate: Date
  public Subject: string
}
